enum RecordStatus {
    Active = 0,
    Original = 1,
    Draft = 2,
    Archived = 3,
    Hidden = 4,
    Deleted = 99
}

export default RecordStatus;
